import { useEffect, useState } from 'react';

/**
 * Tracks whether the viewport is at/below a mobile breakpoint (default 760px).
 * Used by the portal shell to swap the fixed sidebar for an off-canvas drawer.
 */
export function useIsMobile(breakpointPx = 760): boolean {
  const query = `(max-width: ${breakpointPx}px)`;
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = () => setMatches(mql.matches);
    handler();
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
